import * as dialogModels from '../models/dialogModels';
import * as appHelper from './appHelper';

export function newDialog(confgObj){
    return Object.assign({}, dialogModels.DIALOG);
}

/*export function newClickRevealDialog(){
    return Object.assign({}, dialogModels.CLICK_REVEAL_DIALOG);
}*/

export function newAssetDialog(){
    return Object.assign({}, dialogModels.ASSET_DIALOG);
}

export function newScreenDialog(){
    return Object.assign({}, dialogModels.SCREEN_DIALOG);
}

export function setConfig(config){
    //console.log('setConfig', config);
    return Object.assign({}, dialogModels.DIALOG_CONFIG,
        {
            dialogComponent: typeof config.dialogComponent !== 'undefined' ? config.dialogComponent : dialogModels.DIALOG_CONFIG.dialogComponent,
            title: typeof config.title !== 'undefined' ? config.title : dialogModels.DIALOG_CONFIG.title,
            icon: typeof config.icon !== 'undefined' ? config.icon : dialogModels.DIALOG_CONFIG.icon,
            theme: typeof config.theme !== 'undefined' ? config.theme : dialogModels.DIALOG_CONFIG.theme,
            showCloseBtn: typeof config.showCloseBtn !== 'undefined' ? config.showCloseBtn : dialogModels.DIALOG_CONFIG.showCloseBtn,
            onClose: typeof config.onClose !== 'undefined' ? config.onClose : dialogModels.DIALOG_CONFIG.showCloseBtn,
            childComponents: typeof config.childComponents !== 'undefined' ? config.childComponents : dialogModels.DIALOG_CONFIG.childComponents,
            sourceId: typeof config.sourceId !== 'undefined' ? config.sourceId : dialogModels.DIALOG_CONFIG.sourceId
        }
    );
}

export function setScreenConfig(config){
    return Object.assign({}, dialogModels.SCREEN_CONFIG,
        {
            component: appHelper.isDefined(config.component)  ?  config.component : dialogModels.SCREEN_CONFIG.component,
            biteCallbacks: appHelper.isDefined(config.biteCallbacks) ?  config.biteCallbacks : dialogModels.SCREEN_CONFIG.biteCallbacks,
            parentScreen: appHelper.isDefined(config.parentScreen) ?  config.parentScreen : dialogModels.SCREEN_CONFIG.parentScreen,
            screen: appHelper.isDefined(config.screen) ?  config.screen : dialogModels.SCREEN_CONFIG.screen,
            showCloseBtn: appHelper.isDefined(config.showCloseBtn) ?  config.showCloseBtn : dialogModels.SCREEN_CONFIG.showCloseBtn,
            onClose: appHelper.isDefined(config.onClose) ?  config.onClose : dialogModels.SCREEN_CONFIG.onClose,
            sourceId: typeof config.sourceId !== 'undefined' ? config.sourceId : dialogModels.DIALOG_CONFIG.sourceId
        }
    );
}


export function setClass(dialog,className){
    return Object.assign({}, dialog, {className: className});
}

export function setComponent(dialog,className){
    return Object.assign({}, dialog, {className: className});
}

export function clearDialog(){
    return new Promise((resolve, reject) => {
       let dialog = {};
        resolve(dialog);
    });
}

export function setStandardDialog(config){
    return new Promise((resolve, reject) => {

        let dialog = newDialog();
        dialog.config = Object.assign({}, setConfig(config));

        resolve(dialog);
    });
}

export function setAssetDialog(config){
    return new Promise((resolve, reject) => {

        let dialog = newAssetDialog();
        dialog.config = Object.assign({}, setConfig(config));

        resolve(dialog);
    });
}

export function setScreenDialog(config){
    return new Promise((resolve, reject) => {

        let dialog = newScreenDialog();
        dialog.config = Object.assign({}, setScreenConfig(config));

        resolve(dialog);
    });
}

export function setClickReveal(config){
    return new Promise((resolve, reject) => {
/*
        let dialog = newClickRevealDialog();
        dialog.config = Object.assign({}, setConfig(config));

        resolve(dialog);*/

    });
}



/** WEBPACK FOOTER **
 ** ./src/helpers/dialogHelper.js
 **/